/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APICategory
 */
export interface APICategory {
    /**
     * 
     * @type {string}
     * @memberof APICategory
     */
    readonly self: string;
    /**
     * 
     * @type {Date}
     * @memberof APICategory
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APICategory
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APICategory
     */
    name: string;
}

/**
 * Check if a given object implements the APICategory interface.
 */
export function instanceOfAPICategory(value: object): value is APICategory {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APICategoryFromJSON(json: any): APICategory {
    return APICategoryFromJSONTyped(json, false);
}

export function APICategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICategory {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
    };
}

export function APICategoryToJSON(value?: Omit<APICategory, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

